import { render, staticRenderFns } from "./StockTransferReport.vue?vue&type=template&id=18b31169&"
import script from "./StockTransferReport.vue?vue&type=script&lang=js&"
export * from "./StockTransferReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports